<template>
  <div class="left"><slot /></div>
</template>
<script>
export default {};
</script>

<style scoped>
.left {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
}
.left :deep(.text) {
  margin-left: 7px;
}
.left > * {
  margin-right: 25px;
  white-space: nowrap;
}
</style>
